import React, { Component } from 'react';
import { Table , DatePicker,message } from 'antd';
import { RateHistory } from './RateHistory';
import { RateEdit } from './RateEdit';
import Filter from './Filter';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from "../../../common/Fetch";
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import '../style.less';
import moment from 'moment';

const { MonthPicker } = DatePicker;

class RequestRecord extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {
            startEffectDate:moment().format('YYYY-MM'),
            endEffectDate:moment().format('YYYY-MM'),
        },
        pagination: {
            pageSize: 20,
            current: 1,
        },
        isAdd: false,
    }
    componentDidMount(){
        this.loadData();
    }

    loadData = () =>{
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCurrencyExchangeRateList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, datas = [], totalCount } = res;
                const { isAdd } = data || {};
                let originalCurrency = '',endData = {},effectDate = '',newdata = [];
                pagination.total = totalCount;
                datas.forEach((element) => {
                    if(element.dateType == 'MonthStart'){
                        element.monthStart = element.rate;
                        element.monthEnd = element.endRate || '';
                        newdata.push(element)
                    }
                });
                this.setState({
                    loading: false,
                    data: newdata,
                    pagination,
                    isAdd,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.loadData();
        });
    }

    exportReport = () =>{
        const { searchParams } = this.state;
        ExportUtil.export(searchParams, null, API_URL.contract.exportCurrencyExchangeRateList);
        message.success('正在下载中!')
    }

    getColumns = () => [{
        title: '生效日期',
        dataIndex: 'effectDate',
        key: 'effectDate',
        render:text => text ? text.slice(0, 7) : '',
        // //width: 100,
    }, {
        title: '币种',
        dataIndex: 'originalCurrencyName',
        key: 'originalCurrencyName',
        //width: 160,
    }, {
        title: '币种代码',
        dataIndex: 'originalCurrency',
        key: 'originalCurrency',
        //width: 100,
    },{
        title: '月初汇率',
        dataIndex: 'monthStart',
        key: 'monthStart',
        //width: 160,
    },{
        title: '月末汇率',
        dataIndex: 'monthEnd',
        key: 'monthEnd',
        //width: 160,
    } ]

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item }));
        return dataSource;
    }

    handleChange = (value,key)=>{
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }
    
    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    showRateHistory = () => {
        this.rateHistoryRef.show();
    }

    showRateEdit = (record) => {
        this.rateEditRef.show(record);
    }

    onMonthChange = (date ,dateString ,type)=>{
        const { searchParams } =this.state;
        searchParams[type] = dateString;
        this.setState({searchParams})
    }

    render() {
        const { loading, pagination ,searchParams } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='currencyExchangeRate' />
                <div className="main">
                    <Filter 
                        search={this.search}
                        export={this.exportReport}
                        onMonthChange={this.onMonthChange}
                        searchParams={searchParams}
                        showRateHistory={this.showRateHistory}
                        handleChange={this.handleChange}
                    />
                    
                    <Table
                        loading={loading}
                        //scroll={{x: 1160}}
                        pagination={pagination}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        onChange={this.handleTableChange}
                        rowKey={record => record.currencyExchangeRateId}
                    />
                    <RateHistory ref={el => this.rateHistoryRef = el}  />
                    <RateEdit ref={el => this.rateEditRef = el} loadData = {this.loadData} />
                </div>           
            </div>
        )
    }
}

export default RequestRecord;


// WEBPACK FOOTER //
// ./src/components/contractManagement/currencyExchangeRate/index.js